import { b as _slicedToArray, _ as _objectSpread2, c as _objectWithoutProperties } from './transitions-0e124def.esm.js';
import { _ as _toConsumableArray } from './toConsumableArray-a674cb10.esm.js';
import { calc } from '@chakra-ui/theme-tools';
import { textSizes, textCapsizes, headingSizes, headingPresets, headingCapsizes } from '@hover/blueprint-theme';
import { entries, fromEntries } from '@hover/utilities';

var _excluded = ["lineHeight", "fontSize"];
var defineTextStyles = function defineTextStyles(_ref) {
  var textSizes = _ref.textSizes,
    textCapsizes = _ref.textCapsizes,
    headingSizes = _ref.headingSizes,
    headingCapsizes = _ref.headingCapsizes,
    headingPresets = _ref.headingPresets;
  var textEntries = entries(textSizes);
  var headingEntries = entries(headingSizes);
  var styles = fromEntries([].concat(_toConsumableArray(textEntries.map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      size = _ref3[0],
      value = _ref3[1];
    return ["body".concat(size), value];
  })), _toConsumableArray(textEntries.map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      size = _ref5[0],
      value = _ref5[1];
    return ["body".concat(size, "WithCapsize"), _objectSpread2(_objectSpread2({}, value), textCapsizes[size])];
  })), _toConsumableArray(headingEntries.map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
      size = _ref7[0],
      value = _ref7[1];
    return ["heading".concat(size), value];
  })), _toConsumableArray(headingEntries.map(function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
      size = _ref9[0],
      value = _ref9[1];
    return ["heading".concat(size, "WithCapsize"), _objectSpread2(_objectSpread2({}, value), headingCapsizes[size])];
  })), _toConsumableArray(headingEntries.map(function (_ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
      size = _ref11[0],
      value = _ref11[1];
    return ["heading".concat(size, "WithMargin"), _objectSpread2(_objectSpread2({}, value), {}, {
      marginBottom: headingPresets[size].marginBottom
    })];
  })), _toConsumableArray(headingEntries.map(function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
      size = _ref13[0],
      value = _ref13[1];
    return ["heading".concat(size, "WithCapsizeAndMargin"), _objectSpread2(_objectSpread2(_objectSpread2({}, value), headingCapsizes[size]), {}, {
      marginBottom: headingPresets[size].marginBottom
    })];
  })), _toConsumableArray(textEntries.map(function (_ref14) {
    var _ref15 = _slicedToArray(_ref14, 2),
      size = _ref15[0],
      _ref15$ = _ref15[1];
      _ref15$.lineHeight;
      var fontSize = _ref15$.fontSize,
      rest = _objectWithoutProperties(_ref15$, _excluded);
    return ["code".concat(size), _objectSpread2(_objectSpread2({}, rest), {}, {
      fontSize: calc.subtract(fontSize, '1px')
    })];
  }))));
  return styles;
};
var textStyles = /*#__PURE__*/defineTextStyles({
  textSizes: textSizes,
  textCapsizes: textCapsizes,
  headingSizes: headingSizes,
  headingPresets: headingPresets,
  headingCapsizes: headingCapsizes
});

export { defineTextStyles as d, textStyles as t };
